import FormCatalogoIncidencias from "./form";

export default function EditarCatalogoIncidencias() {
    return (
        <FormCatalogoIncidencias
            idIncidencia={localStorage.getItem("incCat")}
        />
    )
}